import { render, staticRenderFns } from "./VersionInfo.vue?vue&type=template&id=efeff898&scoped=true&"
import script from "./VersionInfo.vue?vue&type=script&lang=js&"
export * from "./VersionInfo.vue?vue&type=script&lang=js&"
import style0 from "./VersionInfo.vue?vue&type=style&index=0&id=efeff898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeff898",
  null
  
)

component.options.__file = "VersionInfo.vue"
export default component.exports